<app-admin-sidebar></app-admin-sidebar> <app-adminheader></app-adminheader>
<div class="dash">
  <div class="row mt-5 d-flex align-items-center">
    <span class="setting">Settings</span>
  </div>
  <mat-divider
    class="mat_divider"
    style="border-top-color: #f58634; border-top-width: 2px"
  ></mat-divider>

  <!-- code -->

  <div class="details mt-4">
    <div [class.spinner]="loading"></div>

    <form [formGroup]="settingForm">
      <div class="row d-flex mt-4 align-items-center">
        <div class="col-sm-4">Corporate Push Notifications - Default Timer</div>
        <div class="col-sm-1">
          <mat-form-field
            class="custom-form-field no-error-underline"
            appearance="fill"
          >
            <input
              matInput
              placeholder="MM"
              formControlName="corporate_push_notification_default_timer"
              maxlength="3"
              (input)="formatTime($event, 'corporate_push_notification_default_timer')"
              required
            />
          </mat-form-field>
        </div>
        <div class="col-sm-1">
          <p>Minutes</p>
        </div>
      </div>
      <div class="row d-flex mt-4 align-items-center">
        <div class="col-sm-4">Corporate Ranking Timer</div>
        <div class="col-sm-1">
          <mat-form-field
            class="custom-form-field no-error-underline"
            appearance="fill"
          >
            <input
              matInput
              placeholder="MM"
              formControlName="corporate_ranking_timer"
              maxlength="3"
              (input)="formatTime($event, 'corporate_ranking_timer')"
              required
            />
          </mat-form-field>
        </div>
        <div class="col-sm-1">
          <p>Minutes</p>
        </div>
      </div>
      <div class="row d-flex mt-4 align-items-center">
        <div class="col-sm-4">Quote Expiry Time</div>
        <div class="col-sm-1">
          <mat-form-field
            class="custom-form-field no-error-underline"
            appearance="fill"
          >
            <input
              matInput
              placeholder="MM"
              formControlName="quote_expiry_time"
              maxlength="3"
              (input)="formatTime($event, 'quote_expiry_time')"
              required
            />
          </mat-form-field>
        </div>
        <div class="col-sm-1">
          <p>Minutes</p>
        </div>
      </div>
      <div class="row d-flex mt-4 align-items-center">
        <div class="col-sm-4">Corporate Push Notification - Margin</div>
        <div class="col-sm-1">
          <mat-form-field
            class="custom-form-field no-error-underline"
            appearance="fill"
          >
            <input
              matInput
              formControlName="corporate_push_notification_margin"
              maxlength="3"
              (input)="restrictToNumbers($event)"
              required
            />
          </mat-form-field>
        </div>
      </div>
      <div class="row d-flex mt-4 align-items-center">
        <div class="col-sm-4">Corporate Push Notification</div>
        <div class="col-sm-2">
          <p>
            <mat-slide-toggle
              formControlName="corporate_push_notification"
              class="custom-slide-toggle"
            ></mat-slide-toggle>
          </p>
        </div>
      </div>
      <div class="row d-flex mt-4 align-items-center">
        <div class="col-sm-4">Corporate SMS Notification</div>
        <div class="col-sm-2">
          <p>
            <mat-slide-toggle
              formControlName="corporate_sms_notification"
              class="custom-slide-toggle"
            ></mat-slide-toggle>
          </p>
        </div>
      </div>
      <div class="row d-flex mt-4 align-items-center justify-content-end">
        <div class="col-auto">
          <button
            class="btn btn-custom"
            (click)="updateSettings()"
            type="submit"
            [disabled]="loading"

          >
            Submit
          </button>
        </div>
      </div>
    </form>

    <!-- <div class="row d-flex mt-4 align-items-center">
      <div class="col-sm-4">Retail Push Notification - Margin :</div>
      <div class="col-sm-1">
        <mat-form-field
          class="custom-form-field no-error-underline"
          appearance="fill"
        >
          <input matInput required />
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <button class="btn btn-custom" type="submit">Submit</button>
      </div>
    </div>

    <div class="row d-flex align-items-center">
      <div class="col-sm-4">Retail Push Notification :</div>
      <div class="col-sm-2">
        <p><mat-slide-toggle class="custom-slide-toggle"></mat-slide-toggle></p>
      </div>
    </div>

    <div class="row d-flex mt-4 align-items-center">
      <div class="col-sm-4">Retail SMS Notification :</div>
      <div class="col-sm-2">
        <p><mat-slide-toggle class="custom-slide-toggle"></mat-slide-toggle></p>
      </div>
    </div> -->
  </div>
</div>
